import { MdChevronRight, MdPlayCircle, MdPauseCircle } from "react-icons/md"
import { useEffect, useState, CSSProperties } from "react"
import Layout from "../../components/global/layout"
import { useNavigate, useParams } from "react-router"
import { IoCheckmarkCircle } from "react-icons/io5"
import ApiClient from "../../methods/api/apiClient"
import methodModel from "../../methods/methods"
import loader from "../../methods/loader"
import { FaChevronRight } from "react-icons/fa";
import { FaChevronLeft } from "react-icons/fa";
import SelectDropdown from "../../components/common/SelectDropdown"
import CustomizeCard from "./CustomizeCard"
import PopUp from "../../components/PopUp";
import { useSelector } from "react-redux"
import CardAnimation from "../../components/CardAnimation"
import environment from "../../environment"


const CardDetails = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const user = useSelector((state: any) => state.user)
    const [detail, setDetail]: any = useState()
    const [count, setcount]: any = useState(0)
    const [selectedCard, setSelectedCard]: any = useState({
        recipient_name: "",
        type: "",
        recipient_email: "",
        recipient_dialCode: "",
        recipient_mobileNo: "",
        sender_name: user?.fullName || "",
        receptionTextColor: "",
        receptionTextSize: "30",
        senderTextColor: "",
        senderTextSize: "30",
        envelope: "",
        images: [],
        audio: "",
        video: "",
        receptionTextPosition: {
            top: 10,
            right: 10
        },
    })
    const [isPlaying, setIsPlaying] = useState(false);
    const [selectedAudio, setSelectedAudio] = useState(-1);
    const [audioRef, setAudioRef] = useState<HTMLAudioElement | null>(null);
    const [tab, setTab] = useState("card")
    const [tagsOptions, setTagsOptions] = useState([])
    const [customize, setCustomize] = useState(false)
    const token = sessionStorage.getItem("token")
    const [modal, setModal] = useState({ modal: false, message: "", image: "", buttonText: "", redirectUrl: "" })

    useEffect(() => {
        window.scrollTo(0, 0);
        getCardDetails()
    }, [id])

    const getCardDetails = () => {
        loader(true)
        ApiClient.get(`card/detail?id=${id}`).then((res: any) => {
            if (res.success) {
                setDetail({ ...res.data, stickerStamp2: res?.data?.stickerStamp ? true : false }) // Take stickerStamp2 extra key for handling Sticker Stamp image upload
                setTagsOptions(res?.data?.tags?.map((item: any) => {
                    return ({ id: item, name: item })
                }))
                getSelecteddata({ front_image: res?.data?.envelopeId?.front_image || res?.data?.categoryId?.image, back_image: "", firstImage: res?.data?.image, secondImage: res?.data?.secondImage })
            }
            loader(false)
        })
    }

    const handlePlayPause = (index: number) => {
        if (selectedAudio === index) {
            if (isPlaying) {
                audioRef?.pause();
            } else {
                audioRef?.play();
            }
            setIsPlaying(!isPlaying);
        } else {
            setIsPlaying(true);
            setSelectedAudio(index);
        }
    };

    const getSelecteddata = (selectedData: any) => {
        let envelopeImages = { 0: selectedData?.front_image, 1: detail?.image || selectedData?.firstImage, 2: detail?.secondImage || selectedData?.secondImage, 3: selectedData?.back_image }
        setSelectedCard((prev: any) => ({ ...prev, envelope: selectedData, images: envelopeImages }))
    }

    const decreasecount = () => {
        setcount(count - 1);
    }
    const increasecount = () => {
        setcount(count + 1);
    }

    // Left Side Image CSS
    const textElementStyle: CSSProperties = {
        position: 'absolute',
        top: `${detail?.textPosition?.top}%`,
        right: `${detail?.textPosition?.right}%`,
        fontSize: `${detail?.textSize}px`,
        color: detail?.textColor,
        height: 'auto',
        cursor: 'default',
        userSelect: 'none',
        textAlign: 'center',
        lineHeight: 'normal',
    };
    const imageElementStyle: CSSProperties = {
        position: 'absolute',
        top: `${detail?.imagePosition?.top}%`,
        right: `${detail?.imagePosition?.right}%`,
        width: `${detail?.imageSize}%`,
        cursor: 'default',
    };
    const text2ElementStyle: CSSProperties = {
        position: 'absolute',
        top: `${detail?.text2Position?.top}%`,
        right: `${detail?.text2Position?.right}%`,
        fontSize: `${detail?.text2Size}px`,
        color: detail?.text2Color,
        height: 'auto',
        cursor: 'default',
        userSelect: 'none',
        textAlign: 'center',
        lineHeight: 'normal',
    };
    const stickerStampElementStyle: CSSProperties = {
        position: 'absolute',
        top: `${detail?.stickerStampPosition?.top}%`,
        right: `${detail?.stickerStampPosition?.right}%`,
        width: `${detail?.stickerStampSize}%`,
        cursor: 'default',
    };

    // Right Side Image CSS
    const secondImageTextElementStyle: CSSProperties = {
        position: 'absolute',
        top: `${detail?.secondImageTextPosition?.top}%`,
        right: `${detail?.secondImageTextPosition?.right}%`,
        fontSize: `${detail?.secondImageTextSize}px`,
        color: detail?.secondImageTextColor,
        height: 'auto',
        cursor: 'default',
        userSelect: 'none',
        textAlign: 'center',
        lineHeight: 'normal',
    };
    const secondImageElementStyle: CSSProperties = {
        position: 'absolute',
        top: `${detail?.secondImagePosition?.top}%`,
        right: `${detail?.secondImagePosition?.right}%`,
        width: `${detail?.secondImageSize}%`,
        cursor: 'default',
    };
    const secondImageText2ElementStyle: CSSProperties = {
        position: 'absolute',
        top: `${detail?.secondImageText2Position?.top}%`,
        right: `${detail?.secondImageText2Position?.right}%`,
        fontSize: `${detail?.secondImageText2Size}px`,
        color: detail?.secondImageText2Color,
        height: 'auto',
        cursor: 'default',
        userSelect: 'none',
        textAlign: 'center',
        lineHeight: 'normal',
    };
    const secondImageStickerStampElementStyle: CSSProperties = {
        position: 'absolute',
        top: `${detail?.secondImageStickerStampPosition?.top}%`,
        right: `${detail?.secondImageStickerStampPosition?.right}%`,
        width: `${detail?.secondImageStickerStampSize}%`,
        cursor: 'default',
    };

    const handleAudioSelect = (item: any, index: number) => {
        setSelectedAudio(index)
        setSelectedCard((prev: any) => ({ ...prev, audio: item }))
    }

    const handleCustomize = (e: any) => {
        e.preventDefault()
        if (!token) {
            setModal({ modal: true, message: "To Customize the card you need to login first.", image: "/assets/img/warning.png", buttonText: "Ok", redirectUrl: "/login" })
        } else {
            setCustomize(true)
        }
    }

    const waterMark = () => {
        return <div className="absolute inset-0 pointer-events-none grid grid-cols-4 grid-rows-4 gap-4" style={{ opacity: 0.1 }}>
            {Array(16).fill(0).map((_, i) => (
                <span key={i} className="text-primary text-4xl font-bold select-none transform -rotate-45 flex items-center justify-center">
                    FRUM ME 2 U
                </span>
            ))}
        </div>
    }

    return (
        <>
            <Layout>
                <div className="breads_kram px-4 lg:px-16 pt-6">
                    <div className="flex items-center gap-1 text-gray-600">
                        <p onClick={e => { navigate("/") }} className="cursor-pointer">Home</p>
                        <MdChevronRight />
                        <p onClick={e => setCustomize(false)} className={`font-medium ${customize ? "cursor-pointer" : "text-primary"}`}>Details</p>
                        {customize &&
                            <>
                                <MdChevronRight />
                                <p className="text-primary font-medium">Customize</p>
                            </>
                        }
                    </div>
                </div>
                {customize ?
                    <CustomizeCard
                        cardDetail={detail}
                        setCardDetail={setDetail}
                        selectedCard={selectedCard}
                        setSelectedCard={setSelectedCard}
                        count={count}
                        setcount={setcount}
                        decreasecount={decreasecount}
                        increasecount={increasecount}
                        getSelecteddata={getSelecteddata}
                        handleAudioSelect={handleAudioSelect}
                        selectedAudio={selectedAudio}
                        isPlaying={isPlaying}
                        handlePlayPause={handlePlayPause}
                        setAudioRef={setAudioRef}
                    />
                    :
                    <div className="section-details px-4 lg:px-16 pt-6 lg:pt-20">
                        <div className="grid grid-cols-12 gap-4 xl:gap-8">
                            <div className={`col-span-12 ${tab === "preview" ? "lg:col-span-12" : "lg:col-span-6"}`}>
                                <div className="flex flex-col gap-6 lg:flex-row  ">
                                    <div className="flex lg:flex-col gap-6 xl:gap-10 bg-white rounded-xl shadow px-5 py-8 ">
                                        <div onClick={e => setTab("card")} className={`items_child text-center cursor-pointer group ${tab === "card" && "text-[#F58D18]"}`}>
                                            <div className="relative h-6">
                                                <img src={`/assets/img/ed/icons/${tab === "card" ? "1" : "s1"}.svg`} className="mx-auto" />
                                            </div>
                                            <p className="mt-1 text-[14px] 2xl:text-[16px]">Card</p>
                                        </div>
                                        <div onClick={e => setTab("preview")} className={`items_child text-center cursor-pointer group ${tab === "preview" && "text-[#F58D18]"}`}>
                                            <div className="relative h-6">
                                                <img src={`/assets/img/ed/icons/${tab === "preview" ? "2" : "s2"}.svg`} className="mx-auto" />
                                            </div>
                                            <p className="mt-1 text-[14px] 2xl:text-[16px]">Preview</p>
                                        </div>
                                        {/* {detail?.envelope_details?.length > 0 ?
                                            <div onClick={e => setTab("moreStyle")} className={`items_child text-center cursor-pointer group ${tab === "moreStyle" && "text-[#F58D18]"}`}>
                                                <div className="relative h-6">
                                                    <img src={`/assets/img/ed/icons/${tab === "moreStyle" ? "3" : "s3"}.svg`} className="mx-auto" />
                                                </div>
                                                <p className="mt-1 text-[14px] 2xl:text-[16px]">More Styles</p>
                                            </div>
                                            : null} */}
                                    </div>
                                    {tab !== "preview" ?
                                        <div className={`bg-white shadow-[5px_5px_rgba(0,_98,_90,_0.4),_10px_10px_rgba(0,_98,_90,_0.3),_15px_15px_rgba(0,_98,_90,_0.2),_20px_20px_rgba(0,_98,_90,_0.1),_25px_25px_rgba(0,_98,_90,_0.05)] ${tab === "preview" ? "max-w-[800px] mx-auto" : "w-full"} p-2 rounded-xl border border-gray-200`} style={{ backgroundImage: "url('/assets/img/white-screen.jpg')", backgroundSize: "cover", }} >
                                            {selectedCard?.images?.length == 0 ?
                                                <div className="flex items-center justify-center relative">
                                                    {/* <div className="h-[400px] lg:h-[600px] 2xl:h-[800px] flex items-center justify-center relative"> */}
                                                    {count == 1 ?
                                                        <div className="relative w-full h-full">
                                                            <img src={methodModel.noImg(`${detail?.secondImage}`)} className="h-full mx-auto object-contain w-full" id="image" />
                                                            {waterMark()}
                                                            <div style={secondImageTextElementStyle} className={`p-1 cursor-grab`} dangerouslySetInnerHTML={{ __html: detail?.secondImageText }}></div>
                                                            {detail?.secondImageStickerImage && <img style={secondImageElementStyle} src={detail?.secondImageStickerImage ? methodModel.userImg(detail?.secondImageStickerImage) : "/assets/img/placeholder.png"} className={`p-1`} />}
                                                            {detail?.secondImageText2 && <div style={secondImageText2ElementStyle} className={`p-1`} dangerouslySetInnerHTML={{ __html: detail?.secondImageText2 }}></div>}
                                                            {detail?.secondImageStickerStamp && <img style={secondImageStickerStampElementStyle} src={methodModel.noImg(detail?.secondImageStickerStamp)} className={`p-1`} />}
                                                        </div>
                                                        :
                                                        <div className="relative w-full h-full">
                                                            <img src={methodModel.noImg(`${detail?.image}`)} className="h-full mx-auto object-contain" id="image" />
                                                            {waterMark()}
                                                            <div style={textElementStyle} className={`p-1 cursor-grab`} dangerouslySetInnerHTML={{ __html: detail?.text }}></div>
                                                            {detail?.stickerImage && <img style={imageElementStyle} src={detail?.stickerImage ? methodModel.userImg(detail?.stickerImage) : "/assets/img/placeholder.png"} className={`p-1`} />}
                                                            {detail?.text2 && <div style={text2ElementStyle} className={`p-1`} dangerouslySetInnerHTML={{ __html: detail?.text2 }}></div>}
                                                            {detail?.stickerStamp && <img style={stickerStampElementStyle} src={methodModel.noImg(detail?.stickerStamp)} className={`p-1`} />}
                                                        </div>}
                                                    {count > 0 ? <button type="button" className="absolute left-[1px] bg-[#ffffffa6] w-[30px] h-[30px] rounded-full flex justify-center items-center " onClick={() => decreasecount()} ><FaChevronLeft /></button> : ''}
                                                    {count < 1 ? <button type="button" className="absolute right-[1px] bg-[#ffffffa6] w-[30px] h-[30px] rounded-full flex justify-center items-center" onClick={() => increasecount()} ><FaChevronRight /></button> : ''}
                                                </div>
                                                :
                                                <div className=" flex items-center justify-center relative h-full overflow-hidden">
                                                    {count == 2 ?
                                                        <div className="relative w-full h-full">
                                                            <img src={methodModel.noImg(`${selectedCard?.images[count]}`)} className="h-full mx-auto object-contain w-full" id="image" />
                                                            {waterMark()}
                                                            <div style={secondImageTextElementStyle} className={`p-1 cursor-grab`} dangerouslySetInnerHTML={{ __html: detail?.secondImageText }}></div>
                                                            {detail?.secondImageStickerImage && <img style={secondImageElementStyle} src={detail?.secondImageStickerImage ? methodModel.userImg(detail?.secondImageStickerImage) : "/assets/img/placeholder.png"} className={`p-1`} />}
                                                            {detail?.secondImageText2 && <div style={secondImageText2ElementStyle} className={`p-1`} dangerouslySetInnerHTML={{ __html: detail?.secondImageText2 }}></div>}
                                                            {detail?.secondImageStickerStamp && <img style={secondImageStickerStampElementStyle} src={methodModel.noImg(detail?.secondImageStickerStamp)} className={`p-1`} />}
                                                        </div>
                                                        :
                                                        <div className="relative w-full h-full">
                                                            <img src={selectedCard?.images[count] ? methodModel.noImg(`${selectedCard?.images[count]}`) : "/assets/img/white-screen.jpg"} className="h-full mx-auto object-contain" id="image" />
                                                            {count === 1 || count === 2 ? waterMark() : ""}
                                                            {count === 3 &&
                                                                <>
                                                                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                                                                        <div className="relative w-52 h-52">
                                                                            <img src="/assets/img/black_heart.png" alt="Heart" className="w-full h-full object-contain" />
                                                                            <p className="absolute inset-0 flex items-center justify-center -top-3 text-black text-center text-sm font-semibold py-4 px-6">
                                                                                Touching One Heart At A Time
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="absolute bottom-3 left-4 transform text-white text-sm text-right px-2">
                                                                        <p className="text-md font-semibold text-gray-900"><span className='text-md'>©</span> Copyright</p>
                                                                    </div>
                                                                    <div className="absolute bottom-3 right-4 transform  text-white text-sm text-right  px-2">
                                                                        <p className="text-md font-semibold text-gray-900">FRUM ME 2 U</p>
                                                                        <p className="text-[12px] font-medium text-gray-800">{environment.frontendUrl}</p>
                                                                    </div>
                                                                </>}
                                                            {(count == 1 && selectedCard != 0) &&
                                                                <>
                                                                    <div style={textElementStyle} className={`p-1 cursor-grab`} dangerouslySetInnerHTML={{ __html: detail?.text }}></div>
                                                                    {detail?.stickerImage && <img style={imageElementStyle} src={detail?.stickerImage ? methodModel.userImg(detail?.stickerImage) : "/assets/img/placeholder.png"} className={`p-1`} />}
                                                                </>
                                                            }
                                                            {detail?.text2 && count == 1 && selectedCard != 0 && <div style={text2ElementStyle} className={`p-1`} dangerouslySetInnerHTML={{ __html: detail?.text2 }}></div>}
                                                            {detail?.stickerStamp && count == 1 && selectedCard != 0 && <img style={stickerStampElementStyle} src={methodModel.noImg(detail?.stickerStamp)} className={`p-1`} />}
                                                        </div>}
                                                    {(count > 0 && selectedCard != 0) ? <button type="button" className="absolute left-[1px] bg-[#ffffffa6] w-[30px] h-[30px] rounded-full flex justify-center items-center " onClick={() => decreasecount()} ><FaChevronLeft /></button> : ''}
                                                    {(count < 3 && selectedCard != 0) ? <button type="button" className="absolute right-[1px] bg-[#ffffffa6] w-[30px] h-[30px] rounded-full flex justify-center items-center" onClick={() => increasecount()} ><FaChevronRight /></button> : ''}
                                                </div>
                                            }
                                        </div>
                                        :
                                        <div className="w-full">
                                            <CardAnimation detail={{ ...detail, ...selectedCard }} />
                                        </div>
                                    }
                                </div>
                                {detail?.envelope_details?.length > 0 && tab === "moreStyle" ?
                                    <div className="mt-10">
                                        <p className="mb-2 text-lg font-bold">More Styles</p>
                                        <div className="flex gap-4 xl:gap-6 flex-wrap">
                                            {detail && detail?.envelope_details.map((item: any, index: number) => (
                                                <img onClick={() => getSelecteddata(item)} src={methodModel.noImg(`${item?.front_image}`)} key={index} className={`${item?._id === selectedCard?.envelope?._id ? "border border-primary rounded-md" : "bg-white"} h-32 w-32 object-contain cursor-pointer`} />
                                            ))}
                                        </div>
                                    </div>
                                    : null}
                            </div>
                            {tab === "preview" ? null :
                                <div className="col-span-12 lg:col-span-6 lg:pl-4 xl:pl-8">
                                    <div className="">
                                        <h4 className="text-[26px] lg:text-[24px] 2xl:text-[35px] font-normal capitalize">{detail?.name}</h4>
                                        <p className="text-[18px] 2xl:text-[25px] text-gray-600 font-normal">Starting from ${detail?.price || 0} || {detail?.audio_details ? ("With Audio") : ("With No Audio")}</p>
                                        {detail?.tags?.length > 0 &&
                                            <div className="flex items-center gap-3">
                                                {detail?.tags?.map((item: any, index: number) => {
                                                    return <div key={index} className="bg-primary text-white px-2 py-1 rounded-full">{item}</div>
                                                })}
                                            </div>
                                        }
                                    </div>
                                    <div className="bg-white rounded-xl shadow-lg p-6 mt-6">
                                        <form onSubmit={handleCustomize}>
                                            {/* {!detail?.tags?.length ? null :
                                                <>
                                                    <p className="text-[18px] 2xl:text-[25px]  text-gray-600 font-normal">What kind of event you are having?</p>
                                                    <SelectDropdown
                                                        id="statusDropdown"
                                                        displayValue="name"
                                                        className="mt-1 capitalize mb-8"
                                                        placeholder="Select Event"
                                                        theme="search"
                                                        intialValue={selectedCard?.tag}
                                                        result={(e: any) => setSelectedCard((prev: any) => ({ ...prev, tag: e?.value }))}
                                                        options={tagsOptions}
                                                        isClearable={false}
                                                        required
                                                    />
                                                </>
                                            } */}
                                            <div className="btns_big">
                                                <button type="submit" className="rounded-full w-full bg-primary text-white px-4 py-2 lg:py-2 2xl:py-4 text-lg 2xl:text-xl">Customize</button>
                                            </div>
                                        </form>
                                    </div>
                                    {detail?.audio_details?.length > 0 ? (
                                        <div className="bg-white rounded-xl shadow-lg p-6 mt-6">
                                            <p className="text-[18px] 2xl:text-[25px] text-gray-600 font-normal"> Audio</p>
                                            <div className=" max-h-96 overflow-y-auto overflow-x-hidden mt-4 flex flex-col onlyscroll gap-4 pr-6">
                                                {detail && detail.audio_details.map((audio: any, index: number) => (
                                                    <div key={index} className="p-2 flex justify-between items-center gap-4 cursor-pointer bg-gray-100" onClick={e => handleAudioSelect(audio, index)}>
                                                        <div className="flex gap-4 items-center">
                                                            <img src="/assets/img/music.jpg" className="h-12 w-12 2xl:h-16 2xl:w-16 object-cover rounded-xl" />
                                                            <h4 className="text-[20px] font-normal">{audio?.title}</h4>
                                                        </div>
                                                        <div className="flex items-center gap-4">
                                                            {selectedAudio === index && <IoCheckmarkCircle className="text-3xl text-primary" />}
                                                            {selectedAudio === index && isPlaying ?
                                                                <>
                                                                    <img src="/assets/img/ed/music.gif" className="h-12" />
                                                                    <MdPauseCircle className="text-3xl cursor-pointer" onClick={() => handlePlayPause(index)} />
                                                                </>
                                                                :
                                                                <>
                                                                    {/* <img src="/assets/img/ed/puasemusic.png" className="h-12" /> */}
                                                                    <MdPlayCircle className="text-3xl cursor-pointer" onClick={() => handlePlayPause(index)} />
                                                                </>
                                                            }
                                                        </div>
                                                        <audio ref={(ref) => {
                                                            if (index === selectedAudio) {
                                                                setAudioRef(ref);
                                                            }
                                                        }} controls style={{ display: 'none' }}>
                                                            <source src={`${methodModel.audio(audio?.audio)}`} type="audio/mp3" />
                                                        </audio>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ) : null}
                                    {/* <div className="flex flex-col gap-10 mt-10">
                                        <div className="flex items-start gap-4">
                                            <img src="/assets/img/ed/1.svg" className="h-12 w-12 2xl:h-16 2xl:w-16 object-contain" />
                                            <p className="text-[16px] 2xl:text-[20px] w-[90%] ml-3 2xl:ml-6">Customize everything from your Card to the email your recipients open with colors, photos, and text boxes.</p>
                                        </div>
                                        <div className="flex items-start gap-4">
                                            <img src="/assets/img/ed/2.svg" className="h-12 w-12 2xl:h-16 2xl:w-16 object-contain" />
                                            <p className="text-[16px] 2xl:text-[20px] w-[90%] ml-3 2xl:ml-6">Add additional details, like a schedule of events, travel tips, speakers, and photo galleries, with Blocks.</p>
                                        </div>
                                        <div className="flex items-start gap-4">
                                            <img src="/assets/img/ed/3.svg" className="h-12 w-12 2xl:h-16 2xl:w-16 object-contain" />
                                            <p className="text-[16px] 2xl:text-[20px] w-[90%] ml-3 2xl:ml-6">Streamline planning with open-ended and multiple choice Guest Questions or easy checkbox-style Guest Surveys.</p>
                                        </div>
                                        <div className="flex items-start gap-4">
                                            <img src="/assets/img/ed/4.svg" className="h-12 w-12 2xl:h-16 2xl:w-16 object-contain" />
                                            <p className="text-[16px] 2xl:text-[20px] w-[90%] ml-3 2xl:ml-6">Send via email, text message, or a customized shareable link you can paste and post anywhere.</p>
                                        </div>
                                        <div className="flex items-start gap-4">
                                            <img src="/assets/img/ed/icons/s4.svg" className="h-12 w-12 2xl:h-16 2xl:w-16 object-contain" />
                                            <p className="text-[16px] 2xl:text-[20px] w-[90%] ml-3 2xl:ml-6">Instantly track deliveries, opens, and RSVPs, and get notified of each response when you download the app.</p>
                                        </div>
                                    </div> */}
                                </div>
                            }
                        </div>
                        {/* <div className="grid grid-cols-12 gap-4 pt-4 lg:pt-24">
                            <TabGroup className="w-full col-span-12">
                                <TabList className="w-full border-b flex gap-6 border-gray-200">
                                    <Tab className="text-[25px] data-[selected]:font-bold pb-2 data-[selected]:border-[#000] data-[selected]:border-b-2">Overview</Tab>
                                    <Tab className="text-[25px] data-[selected]:font-bold pb-2 data-[selected]:border-[#000] data-[selected]:border-b-2">FAQs</Tab>
                                </TabList>
                                <TabPanels className="mt-6">
                                    <TabPanel>
                                        <div className="">
                                            <h3 className="text-[30px]">Let’s make this Christmas Special with your loved ones.</h3>
                                            <p className="mt-4">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                        </div>
                                    </TabPanel>
                                    <TabPanel>Content 2</TabPanel>
                                </TabPanels>
                            </TabGroup>
                        </div> */}
                    </div>
                }
            </Layout>
            <PopUp popUp={modal} setPopUp={setModal} redirectUrl={modal?.redirectUrl} />
            <div className="hidden">
                <img src={methodModel.noImg(`${detail?.secondImage}`)} className="h-full mx-auto object-contain" id="image" />
                <img src={methodModel.noImg(`${detail?.image}`)} className="h-full mx-auto object-contain" id="image" />
                <img src={methodModel.noImg(`${selectedCard?.images[0]}`)} className="h-full mx-auto object-contain" id="image" />
                <img src={methodModel.noImg(`${selectedCard?.images[1]}`)} className="h-full mx-auto object-contain" id="image" />
                <img src={methodModel.noImg(`${selectedCard?.images[2]}`)} className="h-full mx-auto object-contain" id="image" />
                <img src={methodModel.noImg(`${selectedCard?.images[3]}`)} className="h-full mx-auto object-contain" id="image" />
            </div>
        </>
    )
}

export default CardDetails